export default __webpack_public_path__ + "17d8a8baa7b5bd5b8b13018e57f98297.svg";